window.$ = require('jquery');
window.jQuery = window.$;

require('core-js/stable');
require('regenerator-runtime/runtime');

require('jquery-ui-dist/jquery-ui.js');

require('angular');

require('angular-cookie');
require('angular-sanitize');
require('angular-ui-bootstrap');
require('angular-ui-router');
require('lodash');
require('restangular');

window.i18next = require('i18next').default;
window.i18nextXHRBackend = require('i18next-xhr-backend');
window.i18nextBrowserLanguageDetector = require('i18next-browser-languagedetector');
require('ng-i18next');

require('mousetrap');
window.UAParser = require('ua-parser-js');

require('./js/other/property.js');

const injectHotjarTrackingCode = require('../app/js/other/hotjar-tracking-code.js').injectHotjarTrackingCode;
injectHotjarTrackingCode();

window.d3 = require('d3');
window.d3.tip = require('d3-tip');
window.c3 = require('c3');

window.Decimal = require('decimal.js');
window.Quill = require('quill');
window.Clipboard = require('clipboard');
require('ui-select');
window.Autolinker = require('autolinker');

require('jquery-bridget');
window.Masonry = require('masonry-layout');
require('imagesloaded');
require('angular-masonry');

require('autofill-event');
require('angulartics/src/angulartics.js');
require('angulartics/src/angulartics-ga.js');
window.download = require('downloadjs');

require('bootstrap/dist/css/bootstrap.css');
require('ui-select/dist/select.css');
require('c3/c3.css');
require('quill/dist/quill.snow.css');
